import { render } from "./DayPage.vue?vue&type=template&id=1c060a3c&scoped=true"
import script from "./DayPage.vue?vue&type=script&lang=js"
export * from "./DayPage.vue?vue&type=script&lang=js"

import "./DayPage.vue?vue&type=style&index=0&id=1c060a3c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c060a3c"]])

export default __exports__